let qrCodeApiInstance = null

export function installQrCodeApi(ref) {
  if (qrCodeApiInstance === null) {
    qrCodeApiInstance = new QrCodeApi(ref)
  }
}

export function getQrCodeApiInstance() {
  return qrCodeApiInstance
}

class QrCodeApi {
  #ref = null

  constructor(ref) {
    this.#ref = ref
  }

  async scan() {
    return await this.#ref.scan()
  }
}